import { Outlet } from 'react-router'

import { cn } from '@fortem-monorepo/js-utilities'
import { GlobalHeader } from '@fortem-monorepo/react-spa'
import { useUserContext } from '@fortem-monorepo/react-spa'
import { Toaster } from '@fortem-monorepo/react-ui'

import { GlobalSidebar } from '@/components/GlobalSidebar'
import { DevTools } from '@/components/dev/DevTools'
import { footerMenu, headerMenu, mainMenu, smartradeMenu } from '@/constants/sidebar'
import { useCreateLayoutContext } from '@/layout.context'

export interface FortemLayoutProps {}

export const FortemLayout: React.FC<FortemLayoutProps> = ({}) => {
  const { isDeveloper } = useUserContext()
  const context = useCreateLayoutContext()

  return (
    <>
      <GlobalSidebar
        headerMenu={headerMenu}
        mainMenus={[smartradeMenu, mainMenu]}
        footerMenu={footerMenu}
      >
        <div
          className={cn('flex flex-col', {
            ['h-svh max-h-svh']: context.layout === 'fill',
            ['h-full']: context.layout === 'normal',
          })}
        >
          <GlobalHeader />
          <main className="relative flex flex-col h-full">
            <Outlet context={context} />
          </main>
        </div>
      </GlobalSidebar>
      <Toaster />
      {isDeveloper(true) && <DevTools />}
    </>
  )
}
